<style>
  #iconStyleUploader .v-chip .v-avatar {
    height: 48px!important;
    min-width: 48px;
    width: 48px!important;
  }
  #iconStyleUploader .v-chip .v-chip__content {
    height: 48px;
  }
  #iconStyleUploader .v-chip .v-avatar img {
    height: 30px;
    width: 30px;
    border-radius: 0;
    margin-right: -10px;
  }
  /*#iconStyleUploader .verte__menu-origin {
    right: 50px;
  }*/
  #iconStyleUploader .verte__controller {
    display: none;
  }
</style>

<template>
  <Modal
    modalName="iconStyleUploader"
    title="Dodawanie nowych ikon"
    v-on:closed="close"
    v-on:opened="opened"
    v-bind:buttons="['']"
  >
    <v-layout row wrap>
      <v-flex xs12 >
        <v-select
          v-bind:items="modes"
          v-model="mode"
        ></v-select>
      </v-flex>
      
      <template v-if="mode == 'Dodane'">
        <v-flex xs12 >
          <div class="text-xs-center">
            <v-chip v-for="icon in iconsExist" v-bind:key="icon">
              <v-avatar>
                <img v-bind:src="`${$store.getters.getApiURL}/static/map_icons/${icon}`"/>
              </v-avatar>
              {{icon}}
            </v-chip>
          </div>
        </v-flex>
      </template>
      <template  v-if="mode == 'Upload'">
        <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
					<img ref="image" v-bind:src="imageUrl" height="150" v-if="imageUrl" v-on:load="loadImage"/>
          <p v-if="imageSize[0] != imageSize[1]" style="color:red">Ikona musi mieć proporcje kwadratu</p>
					<v-text-field label="Select Image" v-on:click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="imageInput"
						accept="image/*"
						v-on:change="onFilePicked"
					/>
          <v-btn color="success" v-on:click="sendIconRaster" v-bind:disabled="imageUrl == '' || imageSize[0] != imageSize[1]"><v-icon>add_circle</v-icon> Dodaj</v-btn>
          <v-btn color="error" v-on:click="clearIconRaster" v-bind:disabled="imageUrl == ''"><v-icon>clear</v-icon> Wyczyść</v-btn>
				</v-flex>
      </template>
      <template  v-if="mode == 'Z szablonu'">
        <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
					<img ref="image" v-bind:src="imageUrl" height="150" v-if="imageUrl" />
          <v-select
            v-bind:items="iconsExistTemplates"
            v-model="iconTemplate"
            >
            <template slot="selection" slot-scope="data">{{data.item}}</template>
            <template slot="item" slot-scope="data">
              <img
                v-bind:src="`${apiURL}/static/map_icons/svg_templates/${data.item}`"
                style="height: 25px;"
              >
              &nbsp; {{data.item}}
            </template>
          </v-select>
          <verte
            picker="square"
            display="widget"
            model="hex"
            v-model="imageColor"
            title="Zmień kolor"
          ></verte>
          
          <v-btn color="success" v-on:click="sendIconVector" v-bind:disabled="imageUrl == ''"><v-icon>add_circle</v-icon> Dodaj</v-btn>
          <v-btn color="error" v-on:click="clearIconVector" v-bind:disabled="imageUrl == ''"><v-icon>clear</v-icon> Wyczyść</v-btn>
				</v-flex>
      </template>

    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import Verte from "verte";
import "verte/dist/verte.css";
import canvg from "canvg";


import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import debounce from "lodash/debounce";
import get from "lodash/get";
import defaults from "lodash/defaults";
import isEqual from "lodash/isEqual";
import filter from "lodash/filter";
import each from "lodash/each";
import find from "lodash/find";
import map from "lodash/map";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
mixin(_, {
  chain,
  get: get,
  defaults,
  debounce,
  isEqual,
  filter,
  each,
  find,
  map,
  keyBy,
  mapValues
});
_.value = value;
_.prototype.value = value;
//window._ = _;

export default {
  components: {
    Modal,
    Verte,
  },
  data: () => ({
    iconsExist: [],
    iconsExistTemplates: [],
    
    modes: ['Dodane', 'Upload', 'Z szablonu'],
    mode: 'Dodane',
    
    imageName: '',
		imageUrl: '',
		imageFile: '',
    imageSize: [0,0],
    
    iconTemplate : '',
    iconTemplateSource : '',
    iconTemplatePrepare : '',
    imageColor: 'ff0000'
  }),
  watch: {
    iconTemplate(_new) {
      this.loadTemplateSource();
    },
    imageColor(_new) {
      this.changeTemplateColor();
    }
  },
  methods: {
    opened() {
      this.getIcons();
      this.getIconsTemplates();
      this.mode = 'Dodane';
    },
    close() {

    },

    getIcons() {
      this.$store.dispatch("getIcons").then(r => {
        this.iconsExist = r.icons;
      });
    },
    getIconsTemplates() {
      this.$store.dispatch("getIconsTemplates").then(r => {
        this.iconsExistTemplates = r.icons;
      });
    },
    
    
    //<editor-fold defaultstate="collapsed" desc="raster">
    pickFile () {
      this.$refs.imageInput.click();
    },	
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) { //brak rozszeżenia
          return;
        }
        const fr = new FileReader ();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {          
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl = '';
        this.imageSize = [0,0];
      }
    },
    loadImage(){
      this.imageSize = [this.$refs.image.naturalWidth, this.$refs.image.naturalHeight];
    },
    sendIconRaster() {
      const formData  = new FormData();

      formData.append(this.imageFile.name, this.imageFile, this.imageFile.name);

      fetch(`${this.apiURL}/icons?token=${this.$store.getters.getToken}`, {
        method: 'POST',
        body: formData
      })
              .then((r) => r.json())
              .then(() => {
                this.clearIconRaster();
        this.$root.$emit("showSnackbar", "success", 'Wysłano ikonę');
        this.getIcons();
      })
              .catch(() => {
                this.$root.$emit("showSnackbar", "error", 'Bład wysyłania');
      });
    },
    clearIconRaster() {
      this.imageName = '';
      this.imageFile = '';
      this.imageUrl = '';
      this.imageSize = [0,0];
      this.$refs.imageInput.value = null;
    },
    //</editor-fold>

    
    //<editor-fold defaultstate="collapsed" desc="vector">
    replaceParams(params, text) {
      const regex = /param\((.+?)\)(?: (.+?))?([;"]{1})/gm;
      text = text.replace(regex, (match, name, _default, end, offset, string) => {
        let value;
        if (name in params) {
          value = params[name];
        } else if (_default) {
          value = _default;
        }
        if (!value) {
          value = '';
        }
        return value + end;
      });
      return text;
    },
    loadTemplateSource() {
      if (this.iconTemplate !== '') {
        fetch(`${this.apiURL}/static/map_icons/svg_templates/${this.iconTemplate}`)
          .then(r => r.text())
          .then(source => {
            this.iconTemplateSource = source;
            this.changeTemplateColor();
          });
      } else {
        this.iconTemplateSource = '';
        this.iconTemplatePrepare = '';
      }
    },
    changeTemplateColor : _.debounce(function(size = 256) {
      const canvas = document.createElement('canvas');
      canvas.width = `${size}`;
      canvas.height = `${size}`;

      if (this.iconTemplateSource !== '') {
        this.iconTemplatePrepare = this.replaceParams({
          fill: this.imageColor
        }, this.iconTemplateSource);

        canvg(canvas, this.iconTemplatePrepare, {
          ignoreDimensions : true,
          scaleWidth : size,
          scaleHeight : size
        });
        this.imageUrl = canvas.toDataURL("image/png");
      }
    }, 500),
    b64toBlob(b64Data, contentType='', name='', sliceSize=512) {
      /*const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }*/

      const blob = new Blob([b64Data] /*byteArrays*/, {
        type: contentType,
        name
      });
      blob.name = name;
      return blob;
    },
    sendIconVector() {
      const formData  = new FormData();
      
      const file = this.b64toBlob(this.iconTemplatePrepare, 'image/svg+xml', this.iconTemplate);
      formData.append(this.iconTemplate, file, this.iconTemplate);

      fetch(`${this.apiURL}/icons?token=${this.$store.getters.getToken}`, {
        method: 'POST',
        body: formData
      })
        .then((r) => r.json())
        .then(() => {
          this.clearIconVector();
          this.$root.$emit("showSnackbar", "success", 'Wysłano ikonę');
          this.getIcons();
        })
        .catch(() => {
          this.$root.$emit("showSnackbar", "error", 'Bład wysyłania');
        });
    },
    clearIconVector() {
      this.imageUrl = '';
      this.iconTemplate = '';
      this.imageColor = '#ff0000';
    },
    //</editor-fold>

  },
  computed: {
    apiURL() {
      return this.$store.getters.getApiURL;
    }
    
  },
  mounted() {
    this.getIcons();
    this.getIconsTemplates();
    //console.log(this);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/settings/modals/IconStyleUploader.vue